import { useCallback } from 'react';

import { Popover, PopoverContent, PopoverTrigger } from '@/components/design-system/popover';
import { useUserTile } from '@/features/header/hooks/useUserTile';

import { UserData } from './UserData';
import { UserMenu } from './UserMenu';

export const UserTile: React.FC = () => {
  const { initials, userName, companyName, open, setOpen, handleLogout } = useUserTile();

  const handleToggleOpen = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  return (
    <Popover open={open} onOpenChange={setOpen} modal>
      <PopoverTrigger asChild>
        <UserData
          open={open}
          name={userName}
          companyName={companyName}
          initials={initials}
          onClick={handleToggleOpen}
        />
      </PopoverTrigger>

      <PopoverContent
        align="start"
        sideOffset={8}
        className="bg-secondary w-44 border-0 p-1 shadow-lg"
        onOpenAutoFocus={(e) => {
          e.preventDefault();
        }}
      >
        <UserMenu handleLogout={handleLogout} />
      </PopoverContent>
    </Popover>
  );
};
